export default __webpack_public_path__ + "static/878-77dfb6c56cfe98bf6e5c2627137e5515.gif";